import { useContext } from 'react';
import AuthContext, { type AuthContextValue } from '../context/AuthContext';

/**
 * Hook to access authentication context
 * @throws {Error} If used outside AuthProvider
 */
export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
